import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";

export const BondModal = ({
  isModalOpen,
  toggleModal,
  selectedBond,
  levels,
  handleLevelChange,
  handleUpdateLevel,
}) => {
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={toggleModal}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={toggleModal}>
        Configurar Niveles del Bono: {selectedBond?.name}
      </ModalHeader>
      <ModalBody>
        {levels.length > 0 ? (
          <Row>
            {levels.map((level, index) => (
              <Col md="6" sm="12" key={level.id} className="mb-3">
                <div className="border rounded p-3 shadow-sm h-100">
                  <Label className="fw-bold d-block mb-2">
                    Nivel {level.name}{" "}
                    <span
                      className={`badge ${level.state ? "bg-success" : "bg-secondary"} ms-2`}
                    >
                      {level.state ? "Activo" : "Inactivo"}
                    </span>
                  </Label>

                  <Input
                    type="number"
                    value={level.porcentage}
                    onChange={(e) => handleLevelChange(index, Number(e.target.value))}
                    disabled={!level.state}
                    min={0}
                    max={100}
                  />

                  <div className="text-end mt-2">
                    <Btn
                      attrBtn={{
                        color: "primary",
                        size: "sm",
                        type: "button",
                        disabled: !level.state,
                        onClick: () => handleUpdateLevel(level),
                      }}
                    >
                      Editar Nivel
                    </Btn>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        ) : (
          <p>Este bono no tiene niveles configurados.</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Btn attrBtn={{ color: "secondary", onClick: toggleModal }}>
          Cerrar
        </Btn>
      </ModalFooter>
    </Modal>
  );
};
